import React from "react";
import ReactDOM from "react-dom";
import { ModalProvider } from "react-modal-hook";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { SWRConfig } from "swr";

import "./misc/validationLocale";

import App from "./App";
import { ToastContainer } from "./common/components/core";
import { store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import { ThemeProviderV2} from '@blueprint/ui';

import "./index.scss";

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <SWRConfig
                value={{
                    revalidateOnFocus: false,
                }}
            >
                <ModalProvider>
                    <BrowserRouter basename="/ui">
                        <ThemeProviderV2>
                            <App />
                            <ToastContainer />
                        </ThemeProviderV2>
                    </BrowserRouter>
                </ModalProvider>
            </SWRConfig>
        </Provider>
    </React.StrictMode>,
    document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
